import { createTheme } from "@mui/material/styles";

const theme = createTheme({
      palette: {
       error: {
            light: "#f3a6a6",
            main: "#e07a7a",
            dark: "#c65f5f",
            contrastText: "#fff",
        },
    },
 });

export default theme;